import { render, staticRenderFns } from "./paste-contact-modal.vue?vue&type=template&id=3edb4ec3"
import script from "./paste-contact-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./paste-contact-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports